import React, { useState } from 'react'
import { cloneDeep } from 'lodash'
import { useDispatch } from 'react-redux'
import './Roles.scss'

import Toast from '../../../../../../common/components/Toast/Toast'
import { API__PRODUCTS, API__USER } from '../../../../../../api'
import {
    USER__SET_NOTIFICATIONS,
    USER__SET_SUBSCRIPTION,
    USER__SET_SUBSCRIPTION_CONSTRAINTS,
    USER__SET_TRIAL_COUNT,
} from '../../../../../../store/actions'
import {
    EDUCATION_GROUP_ID,
    NEW_SUB_TO_TRIAL,
    OLD_SUB_TO_TRIAL,
    PRODUCT_LIST_PAID,
} from '../../../../../constants/ProductConstants'

export default ({
    selectedGroup,
    backButtonText = 'Back',
    actionButtonText = 'Go!',
    onBack = () => {},
    onSelect = () => {},
    onClose = () => {},
    isEditMode,
    userSubscription,
    userId,
    notifications,
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [selectedRole, setSelectedRole] = useState(null)
    const dispatch = useDispatch()

    const onAction = async () => {
        setIsLoading(true)
        try {
            const group = cloneDeep(selectedGroup)
            delete group.userRoleInProjectDtos

            await onSelect({
                group,
                role: selectedRole,
            })
            if (!isEditMode && !Object.values(PRODUCT_LIST_PAID).includes(userSubscription.product.productCode)) {
                const notification = notifications.find(obj => [OLD_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL].includes(obj.type))
                if (selectedGroup.customId === EDUCATION_GROUP_ID) {
                    await API__PRODUCTS.SET_EDUCATION_FREE_SUBSCRIPTION(userSubscription.id)
                } else {
                    await API__USER.RESET_TRIAL(userId)
                }
                dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(userId)))
                dispatch(USER__SET_TRIAL_COUNT(await API__USER.GET_TRIAL_COUNT(userId)))
                dispatch(
                    USER__SET_SUBSCRIPTION_CONSTRAINTS(
                        await API__USER.GET_SUBSCRIPTION_CONSTRAINTS(userSubscription.id),
                    ),
                )
                if (notification) {
                    await API__USER.SET_NOTIFICATION_READ(notification.userId, notification.id)
                    dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(userId)))
                }
            }
            onClose()
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="user-role-modal__roles">
            <ul>
                {selectedGroup.userRoleInProjectDtos.map(role => (
                    <li
                        className={selectedRole && selectedRole.id === role.id ? 'is-selected' : ''}
                        key={role.id}
                        onClick={() => setSelectedRole(role)}
                        data-test="role-item"
                    >
                        <span className="point"></span>
                        {role.roleTranslationDto.text}
                    </li>
                ))}
            </ul>
            <div className="buttons">
                <span onClick={() => onBack()}>{backButtonText}</span>
                <button
                    className="confirmation-dialog__button button"
                    data-size="lg"
                    disabled={!selectedRole || isLoading}
                    data-variant="primary"
                    onClick={() => onAction()}
                    data-test="apply-role"
                >
                    {actionButtonText}
                </button>
            </div>
        </div>
    )
}
